import React from 'react';
import { Body3Regular, Head4 } from '../../lib/font';
import { Row } from '../../lib/utils';
import NewRoundedDropDown from '../DropDown/NewRoundedDropDown';
import NormalToggleButton from '../ToggleButton/NormalToggleButton';
import { colors } from '../../lib/colors';

let sortOptions: any = [
    { code: 'registrationasc', value: '등록순' },
    { code: 'seniorityasc', value: '연차순' },
    { code: 'membercountdesc', value: '회원 많은 순' },
    { code: 'alphabetasc', value: '가나다 순' },
];

type Props = {
    coachSortType: any;
    setCoachSortType: any;
    isVisibleDeleteTrainer: boolean;
    onClickToggleButton: () => void;
    onClickAddTrainer?: () => void;
};

const TrainerManageHeader = ({
    coachSortType,
    setCoachSortType,
    isVisibleDeleteTrainer,
    onClickToggleButton,
    onClickAddTrainer,
}: Props) => {
    return (
        <Row style={{ width: 1192, paddingLeft: 8, justifyContent: 'space-between', alignItems: 'center' }}>
            <Head4 style={{ width: 216 }}>{`강사 리스트`}</Head4>

            <Row style={{ alignItems: 'center', gap: 24 }}>
                <Row style={{ alignItems: 'center' }}>
                    <Body3Regular style={{ color: colors.LAVEL_3, marginRight: 12 }}>
                        {'삭제된 강사 보여주기'}
                    </Body3Regular>
                    <NormalToggleButton isActive={isVisibleDeleteTrainer} callBack={onClickToggleButton} />
                </Row>
                <NewRoundedDropDown
                    datas={sortOptions}
                    selectData={coachSortType}
                    onClickSort={(item) => setCoachSortType(item)}
                />
                {onClickAddTrainer && (
                    <button
                        onClick={onClickAddTrainer}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            height: 40,
                            padding: '0 18px',
                            borderRadius: 10,
                            fontSize: 14,
                            fontWeight: 700,
                            border: 'none',
                            background: 'linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)',
                            color: '#FFFFFF',
                            cursor: 'pointer',
                            boxShadow: '0 8px 18px rgba(37, 99, 235, 0.22)',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        + 강사 등록
                    </button>
                )}
            </Row>
        </Row>
    );
};

export default TrainerManageHeader;
